export enum FeatureFlagPermission {
  Read = 'feature_flags.read',
  Update = 'feature_flags.update',
  All = 'feature_flags.*'
}

export enum UserPermission {
  Create = 'users.create',
  Read = 'users.read',
  Update = 'users.update',
  Delete = 'users.delete',
  Status = 'users.status',
  All = 'users.*'
}

export enum OrganizationPermission {
  Create = 'organizations.create',
  Read = 'organizations.read',
  Update = 'organizations.update',
  Delete = 'organizations.delete',
  Status = 'organizations.status',
  All = 'organizations.*'
}

export enum MemberPermission {
  Create = 'members.create',
  Read = 'members.read',
  ReadDeleted = 'members.read_deleted',
  Update = 'members.update',
  Delete = 'members.delete',
  Status = 'members.status',
  All = 'members.*'
}

export enum PropertyPermission {
  Create = 'properties.create',
  Read = 'properties.read',
  ReadDeleted = 'properties.read_deleted',
  Update = 'properties.update',
  Delete = 'properties.delete',
  Status = 'properties.status',
  All = 'properties.*'
}

export enum TemplatePermission {
  Create = 'templates.create',
  Update = 'templates.update',
  Delete = 'templates.delete',
  All = 'templates.*'
}

export enum RolePermission {
  SysAdmin = 'roles.sys_admin',
  StaffManager = 'roles.staff_manager',
  Staff = 'roles.staff',
  OrgOwner = 'roles.org_owner',
  OrgAdmin = 'roles.org_admin',
  All = 'roles.*'
}

export enum StripePermission {
  CreateAccount = 'stripe.create_account',
  ConnectBank = 'stripe.connect_bank',
  Read = 'stripe.read',
  Unlink = 'stripe.unlink',
  All = 'stripe.*'
}

export enum PaymentsPermission {
  Create = 'payments.create',
  Read = 'payments.read',
  Refund = 'payments.refund',
  Cancel = 'payments.cancel',
  All = 'payments.*'
}

export enum BankReconciliationPermission {
  Read = 'bank_reconciliation.read',
  /** Clearing a transaction: matching, transferring or excluding. Held by every persona but Member. */
  Update = 'bank_reconciliation.update',
  All = 'bank_reconciliation.*'
}

export enum FinancialsPermission {
  Read = 'financials.read',
  ReadDeleted = 'financials.read_deleted',
  CreateExpense = 'financials.create_expense',
  UpdateExpense = 'financials.update_expense',
  VoidExpense = 'financials.void_expense',
  CreateLedgerEntry = 'financials.create_ledger_entry',
  CreateBudget = 'financials.create_budget',
  UpdateBudget = 'financials.update_budget',
  DeleteBudget = 'financials.delete_budget',
  All = 'financials.*'
}

export enum ChartOfAccountsPermission {
  Read = 'chartofaccounts.read',
  Create = 'chartofaccounts.create',
  Update = 'chartofaccounts.update',
  All = 'chartofaccounts.*'
}

export enum BalancesPermission {
  CreateChargeSchedules = 'balances.create_charge_schedule',
  CreateCredits = 'balances.create_credit',
  Read = 'balances.read',
  ReadDeleted = 'balances.read_deleted',
  Update = 'balances.update_charge_schedule',
  Status = 'balances.status',
  Mark = 'balances.mark',
  All = 'balances.*'
}

export enum AuditPermission {
  ReadDetails = 'audits.read_details',
  All = 'audits.*'
}

export enum MessagePermission {
  Read = 'messages.read',
  Send = 'messages.send',
  ManageSuppressions = 'messages.manage_suppressions',
  All = 'messages.*'
}

export enum DocumentsPermission {
  Upload = 'documents.upload',
  Manage = 'documents.manage',
  ManagePermissions = 'documents.manage_permissions',
  All = 'documents.*'
}

export enum AddressPermission {
  /** Sending an address to the verification service. The only address permission the API defines. */
  Verify = 'addresses.verify'
}

export enum ImportPermission {
  Manage = 'imports.manage',
  All = 'imports.*'
}

export enum SupportPermission {
  CreateTicket = 'support.create_ticket',
  All = 'support.*'
}

export type Permission = UserPermission
  | FeatureFlagPermission
  | OrganizationPermission
  | MemberPermission
  | PropertyPermission
  | TemplatePermission
  | RolePermission
  | StripePermission
  | PaymentsPermission
  | BalancesPermission
  | BankReconciliationPermission
  | FinancialsPermission
  | ChartOfAccountsPermission
  | AuditPermission
  | MessagePermission
  | DocumentsPermission
  | AddressPermission
  | ImportPermission
  | SupportPermission;